/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useEffect, useContext, useState } from 'react';
import { Pagination, PaginationItem, PaginationLink, Form, FormGroup, Input, InputGroup, InputGroupAddon, Collapse, Badge, Label, Button, Modal, ModalHeader, ModalBody, ModalFooter, Table, TabPane, TabContent, Nav, NavItem, NavLink } from 'reactstrap';
import Alert from 'react-s-alert';
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';

// import services
import AdminService from '../../services/AdminService';
import GeneralService from '../../services/GeneralService';

const Policies = props => {

    // variables
    let timeout = 0;

    // states
    const [isLoading, setIsLoading] = useState(true);
    const [isLoading2, setIsLoading2] = useState(false);
    const [isLoading3, setIsLoading3] = useState(false);
    const [policies, setPolicies] = useState({ privacy: '', terms: '', cookie: '' });
    const [activeTab, setActiveTab] = useState("privacy");
    const [previewModal, setPreviewModal] = useState({ isVisible: false, policyType: '' });
    const [confirmationModal, setConfirmationModal] = useState({ isVisible: false, policyType: '' });
    const [pagination, setPagination] = useState({ limit: 10, page: 1 });

    // contexts
    const { theme, colors } = useContext(ThemeContext);

    // use Effects
    // will be called when value for pagination changes
    useEffect(() => {
        if (activeTab) {
            setIsLoading(true);
            getPolicy(activeTab);
        }
    }, [activeTab]);

    // call getPolicies api and get data
    const getPolicy = (type) => {
        AdminService.getPolicy(type).then(data => {
            try {
                // set data to state "Policies"
                setPolicies({ ...policies, [type]: data.policy });
                setIsLoading(false);
            } catch (err) {
                Alert.error("Some error occured, please try again later or report support team.", {
                    position: 'top-right',
                    effect: 'slide'
                });
                GeneralService.logError('at Admin Policies useEffect', 'Error in try catch block', err.stack);
                setIsLoading(false);
            }
        });
    }

    // to toggle FAQ div
    // args: type for determine current tab, index for div to toggle
    const toggle = (type, index) => {
        try {
            // create a copy of array
            const tempArray = [...policies[type]];
            // modify array
            tempArray[index].isOpen = !tempArray[index].isOpen;
            // save array
            setPolicies({ ...policies, [type]: tempArray });
        } catch (err) {
            // show error message if error
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            // add error to log
            GeneralService.logError('at Admin Policies toggle', 'Error in try catch block', err.stack);
        }
    };

    //utility function
    // create html_markup
    const createMarkup = (html) => {
        return { __html: html };
    }

    // handle functions
    // handle value change for inputs
    const handleChange = e => {
        try {
            setPolicies({ ...policies, [e.target.name]: e.target.value });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Admin Policies handleChange', 'Error in try catch block', err.stack);
        }
    }

    const handleSave = e => {
        try {
            setIsLoading2(true);
            e.preventDefault();
            AdminService.savePolicy(confirmationModal.policyType, policies[confirmationModal.policyType]).then(data => {
                //     getPolicies();
                setConfirmationModal({ isVisible: false, policyType: '' });
                setIsLoading2(false);
            }).catch(error => {
                Alert.error(error.message.msgBody, {
                    position: 'top-right',
                    effect: 'slide'
                });
                setIsLoading2(false);
            });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            setIsLoading2(false);
            GeneralService.logError('at Admin FAQ handleSave', 'Error in try catch block', err.stack);
        }
    }

    return (
        <main>
            <div className="container-fluid">
                {
                    isLoading ?
                        <h3 className="text-center mt-5">Loading...</h3> :
                        <div>
                            <Nav justified tabs className='mt-4 mx-3'>
                                <NavItem style={{ fontSize: "1.2rem", fontWeight: "600", cursor: "pointer" }}>
                                    <NavLink
                                        style={{ borderWidth: "medium" }}
                                        active={activeTab === "privacy"}
                                        onClick={() => setActiveTab("privacy")}
                                    >
                                        Privacy Policy
                                    </NavLink>
                                </NavItem>
                                <NavItem style={{ fontSize: "1.2rem", fontWeight: "600", cursor: "pointer" }}>
                                    <NavLink
                                        style={{ borderWidth: "medium" }}
                                        active={activeTab === "terms"}
                                        onClick={() => setActiveTab("terms")}
                                    >
                                        Terms Conditions
                                    </NavLink>
                                </NavItem>
                                <NavItem style={{ fontSize: "1.2rem", fontWeight: "600", cursor: "pointer" }}>
                                    <NavLink
                                        style={{ borderWidth: "medium" }}
                                        active={activeTab === "cookie"}
                                        onClick={() => setActiveTab("cookie")}
                                    >
                                        Cookie Policy
                                    </NavLink>
                                </NavItem>
                            </Nav>
                            <TabContent activeTab={activeTab}>
                                <TabPane tabId="privacy">
                                    <div>
                                        <Input className='my-2' type='textarea' name='privacy' value={policies.privacy} onChange={(e) => handleChange(e)} rows="20" />
                                        <div>
                                            <Button className='mr-2' onClick={() => setPreviewModal({ isVisible: true, policyType: 'privacy' })}>Show Preview</Button>
                                            <Button onClick={() => setConfirmationModal({ isVisible: true, policyType: 'privacy' })}>Save</Button>
                                        </div>
                                    </div>
                                </TabPane>
                                <TabPane tabId="terms">
                                    <div>
                                        <Input className='my-2' type='textarea' name='terms' value={policies.terms} onChange={(e) => handleChange(e)} rows="20" />
                                        <div>
                                            <Button className='mr-2' onClick={() => setPreviewModal({ isVisible: true, policyType: 'terms' })}>Show Preview</Button>
                                            <Button onClick={() => setConfirmationModal({ isVisible: true, policyType: 'terms' })}>Save</Button>
                                        </div>
                                    </div>
                                </TabPane>
                                <TabPane tabId="cookie">
                                    <div>
                                        <Input className='my-2' type='textarea' name='cookie' value={policies.cookie} onChange={(e) => handleChange(e)} rows="20" />
                                        <div>
                                            <Button className='mr-2' onClick={() => setPreviewModal({ isVisible: true, policyType: 'cookie' })}>Show Preview</Button>
                                            <Button onClick={() => setConfirmationModal({ isVisible: true, policyType: 'cookie' })}>Save</Button>
                                        </div>
                                    </div>
                                </TabPane>
                            </TabContent>
                        </div>
                }
            </div>
            <Modal size="xl" isOpen={previewModal.isVisible} backdrop={true}>
                <ModalHeader close={<span className="ml-3" style={{ cursor: "pointer" }} onClick={() => setPreviewModal({ isVisible: false, policyType: "" })}><i className="fas fa-times"></i></span>}></ModalHeader>
                <ModalBody>
                    <div dangerouslySetInnerHTML={createMarkup(policies[previewModal.policyType])}></div>
                </ModalBody>
            </Modal>
            <Modal size="sm" isOpen={confirmationModal.isVisible} backdrop={true}>
                <ModalHeader close={<span className="ml-3" style={{ cursor: "pointer" }} onClick={() => setConfirmationModal({ isVisible: false, policyType: "" })}><i className="fas fa-times"></i></span>}><span style={theme.headingBold}>Are you sure?</span></ModalHeader>
                <ModalBody>
                    <Label>Are you sure that you want to update <b>{confirmationModal.policyType}</b> policy?</Label>
                </ModalBody>
                <ModalFooter>
                    <Button type="button" style={theme.formButton} className="btn btn-danger" onClick={(e) => handleSave(e, confirmationModal.policyType)} disabled={isLoading2}>
                        {isLoading2 ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Yes
                    </Button>
                </ModalFooter>
            </Modal>
        </main>
    )

}

export default Policies;